window.reparacoesData = window.reparacoesData || {};

window.reparacoesData["iphone-15-pro-max"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "Sob consulta" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "Sob consulta" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "Sob consulta" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "Sob consulta" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "Sob consulta" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "Sob consulta" }
  ]
};

window.reparacoesData["iphone-15-pro"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "Sob consulta" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "Sob consulta" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "Sob consulta" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "Sob consulta" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "Sob consulta" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "Sob consulta" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["iphone-15-plus"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "Sob consulta" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "Sob consulta" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "Sob consulta" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "Sob consulta" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "Sob consulta" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "Sob consulta" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["iphone-15"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "Sob consulta" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "Sob consulta" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "Sob consulta" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "Sob consulta" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "Sob consulta" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "Sob consulta" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};

window.reparacoesData["iphone-14-pro-max"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "429,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "Sob consulta" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "Sob consulta" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "Sob consulta" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "159,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "299,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-14-pro"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "399,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "Sob consulta" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "Sob consulta" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "Sob consulta" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "149,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "289,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-14-plus"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "359,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "Sob consulta" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "Sob consulta" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "Sob consulta" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "159,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "Sob consulta" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-14"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "259,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "Sob consulta" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "Sob consulta" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "Sob consulta" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "159,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "Sob consulta" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-13-pro-max"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "359,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "74,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "145,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "139,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "139,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "289,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-13-pro"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "329,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "74,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "145,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "139,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "139,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "289,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-13-mini"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "199,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "74,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "145,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "139,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "139,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "289,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-13"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "229,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "74,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "145,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "139,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "139,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "289,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-12-pro-max"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "189,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "64,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "119,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "Sob consulta" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "139,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "289,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-12-pro"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "179,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "64,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "119,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "139,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "229,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-12-mini"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "169,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "64,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "119,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "119,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "189,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-12"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "179,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "64,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "119,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "119,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "229,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-11-pro-max"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "189,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "59,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "79,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "89,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "119,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "189,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-11-pro"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "179,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "59,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "89,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "89,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "129,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "189,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-11"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "149,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "59,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "89,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "89,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "89,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "189,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-xs-max"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "149,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "59,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "79,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "89,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "89,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "129,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-xs"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "109,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "59,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "79,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "89,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "89,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "129,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-x"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "109,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "49,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "69,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "79,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "79,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "129,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-xr"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "99,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "49,90€" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "69,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "84,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "84,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "129,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-se-2022"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "Sob consulta" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "Sob consulta" }
  ],
  "Conector de Carga": [
    { nome: "Conector de Carga", preco: "69,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "Sob consulta" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "Sob consulta" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "Sob consulta" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
window.reparacoesData["iphone-se-2020"] = {
  "Display Touch": [
    { nome: "Display/Touch", preco: "79,90€" }
  ],
  "Bateria": [
    { nome: "Bateria", preco: "44,90€" }
  ],
  "Câmera frontal": [
    { nome: "Câmera frontal", preco: "69,90€" }
  ],
  "Câmera Traseira": [
    { nome: "Câmera Traseira", preco: "69,90€" }
  ],
  "Tampa Traseira": [
    { nome: "Tampa Traseira", preco: "119,90€" }
  ],
  "Outros": [
    { nome: "Descreve a avaria", preco: "Sob consulta" }
  ]
};
